import { completeTrainingModule } from '@metaonia/api-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { clearStartedModule } from './use-started-modules';

import type { TrainingCompletionRequest, TrainingCompletionRequestScoreChoicesItem } from '@metaonia/api-client';

import { generateIdempotencyKey } from '@/lib/idempotency';

/** Re-export as a friendlier alias for component consumers. */
export type ScenarioChoice = TrainingCompletionRequestScoreChoicesItem;

export function useCompleteModule(moduleId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: TrainingCompletionRequest) => {
      return completeTrainingModule(moduleId, payload, {
        headers: { 'Idempotency-Key': generateIdempotencyKey() },
      });
    },
    onSuccess: () => {
      clearStartedModule(moduleId);
      queryClient.invalidateQueries({ queryKey: ['training-progress'] });
      queryClient.invalidateQueries({ queryKey: ['training-modules'] });
    },
  });
}
